<script>
  import { onDestroy, tick } from "svelte";

  /** @type { null | string | HTMLElement } */
  export let target = null;
  /** @type { null | HTMLElement } */
  export let parent = null;
  /** @type { null | string } */
  export let key = null;

  let portal;
  let ref;
  let clone;

  $: checkTarget(key, target);

  function removeChildren(el) {
    if (!el || !el.children) return;
    while (el.children.length > 0) {
      el.removeChild(el.children[0]);
    }
  }

  async function checkTarget(key, target) {
    if (!key) return;

    const t = target || document.body;
    await tick();

    if (typeof t === "string") {
      const targetEl = document.querySelector(t);
      if (!targetEl) return;
      removeChildren(targetEl);
      if (targetEl instanceof HTMLElement) {
        removeChildren(targetEl);
        portal = document.createElement("div");
        portal.classList.add("relative", "w-full", "h-full", "overflow-hidden");
        targetEl.appendChild(portal);
        portal.appendChild(ref);
        parent = clone.parentNode;
      }
    } else if (t instanceof HTMLElement) {
      removeChildren(t);
      portal = document.createElement("div");
      portal.classList.add("relative", "w-full", "h-full", "overflow-hidden");
      t.appendChild(portal);
      portal.appendChild(ref);
      parent = clone.parentNode;
    }
  }

  onDestroy(() => {
    if (portal && portal.parentNode) {
      portal.parentNode.removeChild(portal);
    }
  });
</script>

<div class="portal-clone" bind:this={clone}>
  <div bind:this={ref} class="relative w-full h-full overflow-hidden">
    <slot />
  </div>
</div>

<style>
  .portal-clone {
    display: none;
  }
</style>
